import queryString from 'query-string'
import React, { useEffect, useRef, useState } from 'react'
import { Image, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { CSVLink } from 'react-csv'
import { connect, useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import * as XLSX from 'xlsx'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../../conexoes/api'
import '../../../css/painelFaturas/fatSolicitacoes/tabela.css'
import {
  desabilitarAcoes,
  desabilitarAcoesCliente,
  filtrosArrayBarra,
  limpadorFiltros,
  limpouBusca,
  mudarFiltros,
  mudarManejador,
  mudarPermissaoElementoAcao,
  realizouBusca,
  realizouFiltro,
  recarregarBarraFiltragem,
  revelarBarraFiltragem,
  revelarMostrarEmDispositivosSolicitacao,
  revelarRelatorioFatura,
  revelarRelatorioLinhasAfetadas,
  separadorLinhaBusca
} from '../../../redux/actions/index'
import {
  elipseAmarelo,
  elipseAzul,
  elipseCinza,
  elipseLaranja,
  elipseRoxo,
  elipseVerde,
  elipseVermelho,
  setaDropdown
} from '../../../utils/alternanciaIcones'
import decryptJWT from '../../../utils/decryptJWT'
import { formatarData } from '../../../utils/formatadorDataTabela'
import { columnValue, formatterText } from '../../../utils/tabela.js'
import { validadorPermissaoElemento } from '../../../utils/verificadorPermissaoElemento'
import MensagemErro from '../../componentesModais/mensagens/mensagemErro'
import MensagemInformacao from '../../componentesModais/mensagens/mensagemInformacao'
import Table from '../../Table/index.jsx'

import DetalhamentoSolicitacao from './detalhamento/detalhamentoSolicitacao.js'

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
let itensVar = []
const routeConsultarFatSolicitacoes = '/api/v2/listagemSolConectividade'
const valorLimite = 50

const TableprimaryKey = 'CD_SOLICITACAO'

function TabelaConectSolicitacoes() {
  const [spinAtivo, setSpinAtivo] = useState(true)
  const [itens, setItens] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [permissaoDescricao, setPermissaoDescricao] = useState()
  const [mensagemTitulo, setMensagemTitulo] = useState('')
  const [mensagemParagrafo1, setMensagemParagrafo1] = useState('')
  const [revelarMensagemInformacao, setRevelarMensagemInformacao] =
    useState(false)
  const [itensSelecionados, setItensSelecionados] = useState([])
  const [dadosCsv, setDadosCsv] = useState([])

  const despacho = useDispatch()
  const csvLinkRef = useRef()

  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let limpouBuscaGeral = useSelector(
    (state) => state.manejadorState.limpouBusca
  )
  let realizouBuscaGeral = useSelector(
    (state) => state.manejadorState.realizouBusca
  )
  let filtros = useSelector((state) => state.filtrosState.filtros)
  const buscaArquivo = useSelector(
    (state) => state.buscaArquivoState.buscaArquivo
  )
  let separadorLinha = useSelector(
    (state) => state.manejadorState.separadorLinha
  )
  let ordenador = useSelector((state) => state.manejadorState.ordenador)
  let realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )
  let limparFiltros = useSelector((state) => state.filtrosState.limparFiltros)
  let temFiltros = false

  let relatorioLinhasAfetadas = useSelector(
    (state) => state.faturasState.revelarRelatorioLinhasAfetadas
  )
  let relatorioFatura = useSelector(
    (state) => state.faturasState.revelarRelatorioFatura
  )

  let revelarMostrarEmDispositivo = useSelector(
    (state) => state.faturasState.revelarMostrarEmDispositivosSolicitacao
  )
  let recarregarBarraFiltragemValor = useSelector(
    (state) => state.filtrosState.recarregarBarraFiltragem
  )
  let estadoExpansaoMenu = useSelector(
    (state) => state.manejadorState.expandirNavegacao
  )
  const permissaoElemento = useSelector(
    (state) => state.permissaoState.permissaoElemento
  )
  let revelarBarraFiltro = useSelector(
    (state) => state.filtrosState.revelarBarraFiltragem
  )

  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(760) // 'fatSolicitacoesTabela'
      setColetaUsabilidade(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    function checarFiltros() {
      if (filtros.vazio == 'vazio') {
        temFiltros = false
      } else {
        temFiltros = true
      }
    }
    checarFiltros()
  }, [filtros])

  useEffect(() => {
    const url_query = queryString.parse(window.location.search.substring(1))
    if (url_query.CODIGO_SIMCARD) {
      despacho(mudarFiltros({ CODIGO_SIMCARD: url_query.CODIGO_SIMCARD }))
    }
    despacho(limpadorFiltros(false))
    if (limparFiltros) {
      despacho(revelarBarraFiltragem(false))
      if (!filtros.vazio) {
        despacho(mudarFiltros({ vazio: 'vazio' }))
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    async function pegarSeparador() {
      const separador = await api_gateway
        .get(
          '/m1/consultar/preferencias?cd_pav_usuario=' +
            decryptJWT('codigoCliente')
        )
        .then(function (resposta) {
          return resposta.data.dados[0]
        })
        .catch(function (erro) {
          throw erro.stack
        })
      despacho(separadorLinhaBusca(separador.busca_separador))
    }

    pegarSeparador()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    async function consultarItens() {
      let arrayIccid = []

      const cdSolicitacao = itensSelecionados.CD_SOLICITACAO

      await api_gateway
        .get(
          '/m1/consultar/fat_solicitacao_simcard?cd_fat_solicitacao=' +
            cdSolicitacao
        )
        .then(async function (response) {
          if (response.data.status == 200) {
            await response.data.dados.map((item_consulta) => {
              let auxIccid = "'" + item_consulta.ds_iccid + "'"
              arrayIccid.push(auxIccid)
            })

            despacho(mudarFiltros({ ICCID: arrayIccid }))
            despacho(
              filtrosArrayBarra([
                'Código da Solicitação: ' + cdSolicitacao + '?ICCID'
              ])
            )
            despacho(revelarBarraFiltragem(true))
            despacho(recarregarBarraFiltragem(!recarregarBarraFiltragemValor))
            despacho(limpadorFiltros(false))
            const link = document.getElementById('link-faturas-dispositivos')
            link.click()
          }
        })
        .catch(function (error) {
          return error
        })
    }
    if (revelarMostrarEmDispositivo) {
      ColetaClickstream(1443) // SolicitacoesDropAcoesMostrarEmDispossitivos
      consultarItens()
      despacho(revelarMostrarEmDispositivosSolicitacao(false))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [revelarMostrarEmDispositivo])

  useEffect(() => {
    const controller = new AbortController()
    setSpinAtivo(true)
    despacho(mudarManejador('con_solicitacao'))
    despacho(desabilitarAcoes(true))
    despacho(desabilitarAcoesCliente(false))

    async function carregarTabela() {
      if (limpouBuscaGeral) {
        despacho(limpouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      if (realizouBuscaGeral) {
        despacho(realizouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      if (realizouFiltragem) {
        despacho(realizouFiltro(false))
        restaurarConfigsIniciaisPagina()
      }

      if (temFiltros) {
        temFiltros = false
        restaurarConfigsIniciaisPagina()
      }

      if (totalPaginas != 0) {
        contador = (paginaAtual - 1) * valorLimite
      }

      if (conteudoBusca && filtros.vazio && !buscaArquivo?.chave) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens({ controllerSignal: controller.signal })
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          await contarItens({ controllerSignal: controller.signal })
          const { data } = await api_gateway.get(
            routeConsultarFatSolicitacoes +
              '?contar=true&buscaArquivo=' +
              JSON.stringify(buscaArquivo) +
              '&busca=' +
              conteudoBusca +
              '&separador=' +
              separadorLinha +
              '&offset=' +
              contador +
              '&limit=' +
              valorLimite +
              '&ordenador=' +
              ordenador +
              '&cd_pav_cliente=' +
              decryptJWT('codigoCliente'),
            { signal: controller.signal }
          )
          inserirData(data.devices)
        }
      } else if (!filtros.vazio || buscaArquivo?.chave) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens({ controllerSignal: controller.signal })
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.get(
            routeConsultarFatSolicitacoes +
              '?contar=true&buscaArquivo=' +
              JSON.stringify(buscaArquivo) +
              '&busca=' +
              conteudoBusca +
              '&separador=' +
              separadorLinha +
              '&filtro=' +
              JSON.stringify(filtros) +
              '&offset=' +
              contador +
              '&limit=' +
              valorLimite +
              '&ordenador=' +
              ordenador +
              '&cd_pav_cliente=' +
              decryptJWT('codigoCliente'),
            { signal: controller.signal }
          )
          if (data?.devices) {
            inserirData(data.devices)
          }
        }
      } else {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens({ controllerSignal: controller.signal })
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.get(
            routeConsultarFatSolicitacoes +
              '?offset=' +
              contador +
              '&contar=true&buscaArquivo=' +
              JSON.stringify(buscaArquivo) +
              '&limit=' +
              valorLimite +
              '&ordenador=' +
              ordenador +
              '&cd_pav_cliente=' +
              decryptJWT('codigoCliente'),
            { signal: controller.signal }
          )
          inserirData(data.devices)
        }
      }
      setSpinAtivo(false)
    }
    carregarTabela()
    return () => {
      controller.abort()
    }
  }, [paginaAtual, conteudoBusca, renderizar, filtros, buscaArquivo, ordenador])

  function inserirData(data) {
    if (itensVar.length == totalItens) {
      for (let i = 0; i < totalItens; i++) {
        if (contador === i) {
          let k = i
          for (let j = 0; j < data.length; j++) {
            itensVar[k] = data[j]
            k++
          }
        }
        if (i == totalItens - 1) {
          setItens(JSON.parse(JSON.stringify(itensVar)))
        }
      }
    }
  }

  async function contarItens({ controllerSignal }) {
    let arrayItens = []
    let apiData = []

    if (controladorPagina <= paginaAtual) {
      if (
        controladorPagina <= paginaAtual &&
        filtros.vazio &&
        !buscaArquivo?.chave
      ) {
        apiData = await api_gateway.get(
          routeConsultarFatSolicitacoes +
            '?contar=true&busca=' +
            conteudoBusca +
            '&separador=' +
            separadorLinha +
            '&cd_pav_cliente=' +
            decryptJWT('codigoCliente'),
          { signal: controllerSignal }
        )
      } else {
        apiData = await api_gateway.get(
          routeConsultarFatSolicitacoes +
            '?contar=true&buscaArquivo=' +
            JSON.stringify(buscaArquivo) +
            '&filtro=' +
            JSON.stringify(filtros) +
            '&busca=' +
            conteudoBusca +
            '&separador=' +
            separadorLinha +
            '&cd_pav_cliente=' +
            decryptJWT('codigoCliente'),
          { signal: controllerSignal }
        )
      }
      itensVar = []
      if (apiData.data.devices) {
        totalPaginas = Math.ceil(apiData.data.item_count / valorLimite)
        totalItens = apiData.data.item_count
        for (var i = 0; i < apiData.data.item_count; i++) {
          arrayItens.push(i)
        }
        itensVar = arrayItens
      }
    }
  }

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 0
    setPaginaAtual(1)
  }

  function handlerDesativarImagens(imagem, terminacao) {
    const elementosAtivosDESC = document.querySelectorAll(
      '.icone-ordenacao-DESC'
    )
    const elementosAtivosASC = document.querySelectorAll('.icone-ordenacao-ASC')
    elementosAtivosDESC.forEach((el) => el.classList.add('d-none'))
    elementosAtivosASC.forEach((el) => el.classList.add('d-none'))
    elementosAtivosDESC.forEach((el) =>
      el.classList.remove('icone-ordenacao-DESC')
    )
    elementosAtivosASC.forEach((el) =>
      el.classList.remove('icone-ordenacao-ASC')
    )

    if (imagem) {
      imagem.classList.remove('d-none')
      imagem.classList.add('icone-ordenacao-' + terminacao)
    }
  }

  function handleRemoverImagens(imagem) {
    const elementosAtivosDESC = document.querySelectorAll(
      '.icone-ordenacao-DESC'
    )
    const elementosAtivosASC = document.querySelectorAll('.icone-ordenacao-ASC')
    elementosAtivosDESC.forEach((el) => el.classList.add('d-none'))
    elementosAtivosASC.forEach((el) => el.classList.add('d-none'))
    elementosAtivosDESC.forEach((el) =>
      el.classList.remove('icone-ordenacao-DESC')
    )
    elementosAtivosDESC.forEach((el) =>
      el.classList.remove('icone-ordenacao-ASC')
    )
    elementosAtivosASC.forEach((el) =>
      el.classList.remove('icone-ordenacao-ASC')
    )
    elementosAtivosASC.forEach((el) =>
      el.classList.remove('icone-ordenacao-DESC')
    )
    imagem.classList.remove('icone-ordenacao-ASC')
    imagem.classList.remove('icone-ordenacao-DESC')
  }

  async function handlerOrdenador(nomeOrdenador, nomeDiferenciado) {
    let isItDescrescente = false
    const imagem = document.getElementById(nomeOrdenador + nomeDiferenciado)
    if (
      nomeOrdenador === ordenador.split(' ASC')[0] ||
      nomeOrdenador === ordenador.split(' DESC')[0]
    ) {
      await ordenador.split(' ').map((item_ordenador) => {
        if (item_ordenador === 'ASC') {
          ordenador = nomeOrdenador + ' DESC'
          isItDescrescente = true
          handlerDesativarImagens(imagem, 'ASC')
        }
        if (item_ordenador === 'DESC') {
          ordenador = ''
          isItDescrescente = false
          handleRemoverImagens(imagem)
        }
      })
    } else if (!isItDescrescente) {
      ordenador = nomeOrdenador + ' ASC'
      handlerDesativarImagens(imagem, 'DESC')
    }
  }

  const colunas = [
    {
      dataField: 'DESC_TIPO_SOLICITACAO',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome-tabela-nova fonte-cor-1"
          onClick={() =>
            handlerOrdenador('DESC_TIPO_SOLICITACAO', 'DESC_TIPO_SOLICITACAO')
          }
        >
          Tipo solicitação
          <Image
            id="DESC_TIPO_SOLICITACAODESC_TIPO_SOLICITACAO"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: columnValue
    },
    {
      dataField: 'DESC_STATUS_SOLICITACAO',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome-tabela-nova fonte-cor-1"
          onClick={() =>
            handlerOrdenador(
              'DESC_STATUS_SOLICITACAO',
              'DESC_STATUS_SOLICITACAO'
            )
          }
        >
          Status
          <Image
            id="DESC_STATUS_SOLICITACAODESC_STATUS_SOLICITACAO"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: (cell, row) => {
        if (cell && cell.toLowerCase() == 'aberta') {
          return (
            <OverlayTrigger
              delay={{ show: 500, hide: 250 }}
              placement="bottom"
              overlay={
                <Tooltip id="tooltip-bottom" className="tooltip-busca">
                  {cell}
                </Tooltip>
              }
            >
              <p
                className="fonte-cor-1 label-tabela-1 label-tabela-tooltip"
                key={row.CD_SIMCARD}
              >
                <Image className="img-eclipse-status" src={elipseAmarelo()} />
                Aberta
              </p>
            </OverlayTrigger>
          )
        }
        if (cell && cell.toLowerCase() == 'cancelada') {
          return (
            <OverlayTrigger
              delay={{ show: 500, hide: 250 }}
              placement="bottom"
              overlay={
                <Tooltip id="tooltip-bottom" className="tooltip-busca">
                  {cell}
                </Tooltip>
              }
            >
              <p
                className="fonte-cor-1 label-tabela-1 label-tabela-tooltip"
                key={row.CD_SIMCARD}
              >
                <Image className="img-eclipse-status" src={elipseCinza()} />
                Cancelada
              </p>
            </OverlayTrigger>
          )
        }
        if (cell && cell.toLowerCase() == 'concluída') {
          return (
            <OverlayTrigger
              delay={{ show: 500, hide: 250 }}
              placement="bottom"
              overlay={
                <Tooltip id="tooltip-bottom" className="tooltip-busca">
                  {cell}
                </Tooltip>
              }
            >
              <p
                className="fonte-cor-1 label-tabela-1 label-tabela-tooltip"
                key={row.CD_SIMCARD}
              >
                <Image className="img-eclipse-status" src={elipseVerde()} />
                Concluída
              </p>
            </OverlayTrigger>
          )
        }
        if (cell && cell.toLowerCase() == 'em andamento') {
          return (
            <OverlayTrigger
              delay={{ show: 500, hide: 250 }}
              placement="bottom"
              overlay={
                <Tooltip id="tooltip-bottom" className="tooltip-busca">
                  {cell}
                </Tooltip>
              }
            >
              <p
                className="fonte-cor-1 label-tabela-1 label-tabela-tooltip"
                key={row.CD_SIMCARD}
              >
                <Image className="img-eclipse-status" src={elipseAzul()} />
                Em andamento
              </p>
            </OverlayTrigger>
          )
        }
        if (cell && cell.toLowerCase() == 'agendada') {
          return (
            <OverlayTrigger
              delay={{ show: 500, hide: 250 }}
              placement="bottom"
              overlay={
                <Tooltip id="tooltip-bottom" className="tooltip-busca">
                  {cell}
                </Tooltip>
              }
            >
              <p
                className="fonte-cor-1 label-tabela-1 label-tabela-tooltip"
                key={row.CD_SIMCARD}
              >
                <Image className="img-eclipse-status" src={elipseRoxo()} />
                Agendada
              </p>
            </OverlayTrigger>
          )
        }
        if (cell && cell.toLowerCase() == 'concluída parcial') {
          return (
            <OverlayTrigger
              delay={{ show: 500, hide: 250 }}
              placement="bottom"
              overlay={
                <Tooltip id="tooltip-bottom" className="tooltip-busca">
                  {cell}
                </Tooltip>
              }
            >
              <p
                className="fonte-cor-1 label-tabela-1 label-tabela-tooltip"
                key={row.CD_SIMCARD}
              >
                <Image className="img-eclipse-status" src={elipseLaranja()} />
                Concluída parcial
              </p>
            </OverlayTrigger>
          )
        }
        if (cell && cell.toLowerCase() == 'falha') {
          return (
            <OverlayTrigger
              delay={{ show: 500, hide: 250 }}
              placement="bottom"
              overlay={
                <Tooltip id="tooltip-bottom" className="tooltip-busca">
                  {cell}
                </Tooltip>
              }
            >
              <p
                className="fonte-cor-1 label-tabela-1 label-tabela-tooltip"
                key={row.CD_SIMCARD}
              >
                <Image className="img-eclipse-status" src={elipseVermelho()} />
                Falha
              </p>
            </OverlayTrigger>
          )
        }
      }
    },
    {
      dataField: 'CD_SOLICITACAO',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome-tabela-nova fonte-cor-1"
          onClick={() => handlerOrdenador('CD_SOLICITACAO', 'CD_SOLICITACAO')}
        >
          Cod. Solicitação
          <Image
            id="CD_SOLICITACAOCD_SOLICITACAO"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: formatterText
    },
    {
      dataField: 'DATA_CRIACAO',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome-tabela-nova fonte-cor-1"
          onClick={() => handlerOrdenador('DATA_CRIACAO', 'DATA_CRIACAO')}
        >
          Data da solicitação
          <Image
            id="DATA_CRIACAODATA_CRIACAO"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: (cell) => {
        return formatarData(cell, false)
      }
    },
    {
      dataField: 'DS_EMAIL',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome-tabela-nova fonte-cor-1"
          onClick={() => handlerOrdenador('DS_EMAIL', 'DS_EMAIL')}
        >
          Usuário
          <Image
            id="DS_EMAILDS_EMAIL"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: formatterText
    }
  ]

  function handleMensagemErro(confirmacao) {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
      if (confirmacao === true) {
        setRenderizar(!renderizar)
      }
    }
  }

  useEffect(() => {
    async function handlerVerificarPermissaoAcao() {
      const validarPermissoes = await validadorPermissaoElemento(
        permissaoElemento,
        'veye/solicitacoes/conectividade/relatorios'
      )

      despacho(mudarPermissaoElementoAcao(!validarPermissoes))

      setPermissaoDescricao(
        await validadorPermissaoElemento(
          permissaoElemento,
          'veye/solicitacoes/conectividade/detalhamento'
        )
      )
    }
    handlerVerificarPermissaoAcao()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissaoElemento])

  useEffect(() => {
    if (relatorioLinhasAfetadas !== false) {
      const { CD_SOLICITACAO, DESC_TIPO_SOLICITACAO, JSON_DETAILS } =
        itensSelecionados

      if (DESC_TIPO_SOLICITACAO === 'Destravar IMEI') {
        if (!JSON_DETAILS) {
          despacho(revelarRelatorioLinhasAfetadas(false))
          return
        }

        if (relatorioLinhasAfetadas === 'CSV') {
          const dadosOriginais = JSON.parse(JSON_DETAILS)
          const dados = Array.isArray(dadosOriginais)
            ? dadosOriginais
            : [dadosOriginais]

          dados.map((item) => ({
            Linha: item.Linha,
            IMEI: item.IMEI,
            Descrição: item.Detalhes || '-',
            Status: item.Status
          }))

          setDadosCsv(dados)

          setTimeout(() => {
            csvLinkRef.current.link.click()
          }, 250)
        } else if (relatorioLinhasAfetadas === 'XLSX') {
          try {
            const dadosOriginais = JSON.parse(JSON_DETAILS)

            const dados = dadosOriginais.map((item) => ({
              Linha: item.Linha,
              IMEI: item.IMEI,
              Descrição: item.Detalhes || '-',
              Status: item.Status
            }))

            const ws = XLSX.utils.json_to_sheet(dados)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, ws, 'Relatorio')

            XLSX.writeFile(wb, `linhas-afetadas-${CD_SOLICITACAO}.xlsx`)
          } catch (e) {
            console.error('Erro ao converter JSON_DETAILS:', e)
          }
        }

        despacho(revelarRelatorioLinhasAfetadas(false))
        return
      }

      const dados = {
        codigo_cliente: decryptJWT('codigoCliente'),
        codigo_usuario: decryptJWT('codigo'),
        descricao: 'Relatório de linhas afetadas por solicitação',
        tipo_arquivo: relatorioLinhasAfetadas,
        tipo_relatorio: 29,
        cd_crm_solicitacao: CD_SOLICITACAO,
        buscaArquivo
      }

      api_gateway.post('/m1/cadastrar/relatorios', dados)
      setMensagemTitulo('O arquivo está sendo gerado')
      setMensagemParagrafo1(
        'Esse processo levará alguns minutos, você poderá fazer o download do seu arquivo na tela de relatórios assim que o link do mesmo estiver disponível'
      )
      handleMensagemInformacao(true)
      despacho(revelarRelatorioLinhasAfetadas(false))
    }
  }, [relatorioLinhasAfetadas])

  useEffect(() => {
    if (relatorioFatura !== false) {
      const dados = {
        codigo_solicitacao: itensSelecionados.CD_SOLICITACAO,
        codigo_cliente: decryptJWT('codigoCliente'),
        codigo_usuario: decryptJWT('codigo'),
        descricao: 'Relatório de linhas ignoradas',
        tipo_arquivo: relatorioFatura,
        tipo_relatorio: 18,
        buscar: itensSelecionados.CD_SOLICITACAO,
        buscaArquivo
      }
      api_gateway.post('/m1/cadastrar/relatorios', dados)
      setMensagemTitulo('O arquivo está sendo gerado')
      setMensagemParagrafo1(
        'Esse processo levará alguns minutos, você poderá fazer o download do seu arquivo na tela de relatórios assim que o link do mesmo estiver disponível'
      )
      handleMensagemInformacao(true)
      despacho(revelarRelatorioFatura(false))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [relatorioFatura])

  function handleMensagemInformacao() {
    if (revelarMensagemInformacao === false) {
      setRevelarMensagemInformacao(true)
    } else {
      setRevelarMensagemInformacao(false)
    }
  }

  const renderDetalhamentoLinha = (row) => {
    return (
      <div
        className={
          estadoExpansaoMenu === true
            ? 'expand-row-tabela-solicitacoes-1'
            : 'expand-row-tabela-solicitacoes-2'
        }
      >
        <DetalhamentoSolicitacao
          cdSolicitacao={row.CD_SOLICITACAO}
          tipoSolicitacao={row.DESC_TIPO_SOLICITACAO}
        />
      </div>
    )
  }

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      ColetaClickstream(1227)
      setItensSelecionados(row)

      despacho(desabilitarAcoes(false))
      despacho(desabilitarAcoesCliente(true))
    }
  }

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  const itensSelecionadosTable = itensSelecionados?.[TableprimaryKey]
    ? [itensSelecionados[TableprimaryKey]]
    : []

  return (
    <div className="container-tela">
      <Table
        keyField={TableprimaryKey}
        clickToSelect
        revelarContador
        itens={itens}
        colunas={colunas}
        spinAtivo={spinAtivo}
        revelarBarraFiltro={revelarBarraFiltro}
        permissaoDetalhamentoLinha={permissaoDescricao}
        detalhamentLinha={renderDetalhamentoLinha}
        getTotalItensNaPagina={getTotalItensNaPagina}
        getLimiteNaPagina={getTotalItensNaPagina}
        pagination={{
          paginaAtual,
          valorLimite,
          totalPaginas,
          totalItens,
          contador,
          trocarPagina
        }}
        selection={{
          itensSelecionados: itensSelecionadosTable,
          modeSelection: 'radio',
          handleOnSelect
        }}
      />

      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}

      {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              handleMensagemErro={handleMensagemErro}
              mensagemTitulo="Erro"
              mensagemParagrafo1="Essa solicitação já está concluída"
              mensagemParagrafo2="e não pode ser editada."
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}
      {revelarMensagemInformacao && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemInformacao
              handleMensagemInformacao={handleMensagemInformacao}
              mensagemTitulo={mensagemTitulo}
              mensagemParagrafo1={mensagemParagrafo1}
              mensagemBotao="Continuar"
            />
          </div>
        </div>
      )}
      <Link
        id="link-faturas-dispositivos"
        className="d-none"
        to="/veye/faturas/dispositivos"
      />

      <CSVLink
        ref={csvLinkRef}
        data={dadosCsv}
        filename={`linhas-afetadas-${itensSelecionados?.CD_SOLICITACAO}.csv`}
        className="d-none"
        separator=";"
      />
    </div>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros,
    buscaArquivo: state.buscaArquivoState.buscaArquivo
  }
}

export default connect(mapStateToProps)(React.memo(TabelaConectSolicitacoes))
